// Central cookie-consent + analytics gating.
// This is the single place to wire in an analytics provider later: nothing
// loads unless the visitor has explicitly accepted non-essential storage.

const CONSENT_KEY = 'poettik_cookie_consent';     // 'accepted' | 'rejected' | null
const CONSENT_EVENT = 'poettik-consent-change';

export const getConsent = () => {
  try { return localStorage.getItem(CONSENT_KEY); } catch { return null; }
};

export const hasAnalyticsConsent = () => getConsent() === 'accepted';

let analyticsLoaded = false;

// Initialise analytics. No provider is installed yet — add the script/init
// here and it will only ever run after consent.
export const loadAnalytics = () => {
  if (!hasAnalyticsConsent() || analyticsLoaded) return;
  analyticsLoaded = true;
  // TODO: initialise analytics here once a provider is chosen, e.g.:
  //   const s = document.createElement('script');
  //   s.src = 'https://cdn.example-analytics.com/script.js';
  //   s.async = true;
  //   document.head.appendChild(s);
};

// Called when consent is rejected or withdrawn. Tear down / disable any
// analytics provider added above.
export const disableAnalytics = () => {
  analyticsLoaded = false;
};

export const setConsent = (value) => {
  try {
    localStorage.setItem(CONSENT_KEY, value);
    // Keep the legacy flag in sync for any older reads.
    localStorage.setItem('poettik_cookies_accepted', value === 'accepted' ? 'true' : 'false');
  } catch { /* storage unavailable */ }
  if (value === 'accepted') loadAnalytics();
  else disableAnalytics();
  window.dispatchEvent(new CustomEvent(CONSENT_EVENT, { detail: value }));
};

export const onConsentChange = (cb) => {
  const handler = (e) => cb(e.detail);
  window.addEventListener(CONSENT_EVENT, handler);
  return () => window.removeEventListener(CONSENT_EVENT, handler);
};

// Call once on app start: load analytics only if the visitor already consented.
export const initConsent = () => {
  if (hasAnalyticsConsent()) loadAnalytics();
};
